import React from "react";
import { PaginasCustomizadasProvider } from "./context/paginas-customizadas-context";
import { PaginasCustomizadas } from "./paginas-customizadas";
import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory";

export const PaginasCustomizadasFactory = () => {
    return (
        <BaseInternalFormFactory pageTitle={"Paginas Customizadas"}>
            <PaginasCustomizadasProvider>
                <PaginasCustomizadas />
            </PaginasCustomizadasProvider>
        </BaseInternalFormFactory >
    );
};
